import isString from './isString';

export default function isStrings(u: unknown): u is string[] {
  return Array.isArray(u) && u.some(item => isString(item));
}
